import {combineReducers} from "redux";
import leapSale from "./leapSale";
import paging from "./paging";
import filter from "./filter";
import queue from "./queue";


const leapBettingReducer = combineReducers({
    leapSale,
    paging,
    filter,
    queue
});
export default leapBettingReducer;